module.exports = __webpack_public_path__ + "static/scoring-2-8120954825108c012652e881aa7da448.svg";